import { UUID } from 'crypto'
import DevelopusTreeTableCellsUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellsUIModel'
import DevelopusTreeTableCellUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableCellUIModel'
import DevelopusTreeTableRowUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableRowUIModel'
import DevelopusTreeTableBodyUIModel from '../../../common/ui/treetable/model/DevelopusTreeTableBodyUIModel'
import VehicleLicenseType from '../../../domain/vehicle/VehicleLicenseType'
import { t } from 'i18next'

export type LicenseUI = {
  id?: UUID
  studentId?: UUID
  type: string
  vehicleLicense: VehicleLicenseType
  examFailNumber: number
  description: string
  active: boolean
  restricted: boolean
  success: boolean
  successDate: Date | undefined
  renewalDate: Date | undefined
  licenseProtocolNumber: string | undefined
}

export const getLicenseTreeTable = (
  licenseUI: LicenseUI,
): DevelopusTreeTableRowUIModel => {
  if (licenseUI.success) {
    const licenseCell = new DevelopusTreeTableCellUIModel(
      t(`users.vehicles.${licenseUI.vehicleLicense.getId()}`),
    )
    licenseCell.setColor('green')

    const cells = new DevelopusTreeTableCellsUIModel([
      new DevelopusTreeTableCellUIModel(''),
      new DevelopusTreeTableCellUIModel(''),
      licenseCell,
      new DevelopusTreeTableCellUIModel(''),
      new DevelopusTreeTableCellUIModel(''),
    ])

    return new DevelopusTreeTableRowUIModel(
      licenseUI.id,
      cells,
      new DevelopusTreeTableBodyUIModel([]),
    )
  }

  throw Error('error message here...')
}
